$=jQuery;

/*
* Evento de clique no breadcrumb de galeria
*/
$('.jc-post-breadcrumb a').on('click', function() {

  dataLayer.push({
    'event' : 'ga_event',
    'eventCategory' :'Galeria',
    'eventAction' : 'Clique - Breadcrumb',
    'eventLabel' : $(this).text()
  });

  gtag('event', 'Galeria', {
    'eventAction' : 'Clique - Breadcrumb',
    'eventLabel' : $(this).text()
  });
});

/*
* Evento de clique no nos cards relacionados de galeria
*/
$('.related-galleries-listing .jc-post-thumb a').on('click', function() {

  dataLayer.push({
    'event' : 'ga_event',
    'eventCategory' :'Galeria',
    'eventAction' : 'Clique - Card',
    'eventLabel' : $(this).find('.jc-post-thumb-title').text()
  });

  gtag('event', 'Galeria', {
    'eventAction' : 'Clique - Card',
    'eventLabel' : $(this).find('.jc-post-thumb-title').text()
  });
});

//dispara chatbeat com os parametros recebidos
function galleryPushChartbeat (product, title){
    dataLayer.push({
    'event':'chartbeat',
    'pageSection': product +'-galerias,'+ product +'-geral',
    'pageAuthor': product,
    'pageTitle': title
    });

    gtag('event', 'chartbeat', {
      'pageSection': product +'-galerias,'+ product +'-geral',
      'pageAuthor': product,
      'pageTitle': title
    });
}

//dispara datalayer de slick gallery
function galleryPushSlickGallery(){
    dataLayer.push({
        'event': 'slickGallery'
    });

    gtag('event', 'slickGallery');
}

//dispara datalayer de taxa de visualização de galeria
function galleryPushViewTax( category, title, tax ){

    dataLayer.push({
        'event' : 'galleryViewTax',
        'eventCategory' : category,
        'eventAction' : 'Taxa de visualização',
        'eventLabel' : title,
        'eventValue' : tax
    });

    gtag('event', 'galleryViewTax', {
      'eventCategory' : category,
      'eventAction' : 'Taxa de visualização',
      'eventLabel' : title,
      'eventValue' : tax
    });

}

function galleryPushEventView ( slide ){

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Galeria',
    'eventAction': 'Clique - Setas',
    'eventLabel': slide
  });

  dataLayerEstadao.push({
    'event': 'genericEvent',
    'genericCategory': 'engajamento',
    'genericAction': ('galerias_' + jQuery(".jc-post-breadcrumb a").text().trim().replace(" ","_").toLowerCase()).replace(/\_$/, ''),
    'genericLabel': slide
  });

  gtag('event', 'Galeria', {
    'eventAction': 'Clique - Setas',
    'eventLabel': slide
  });

  gtag('event', 'engajamento', {
    'genericAction': ('galerias_' + jQuery(".jc-post-breadcrumb a").text().trim().replace(" ","_").toLowerCase()).replace(/\_$/, ''),
    'genericLabel': slide
  });

}
